export const STEP_MSCORE_TYPE = 'mscore';

/**
 * mScore step detail
 */
export default class EQmScoreStepConfig {

    /**
     * Default constructor
     *
     * @param {string} direction
     * @param {number} socketCount
     * @param {number} service
     * @param {number} module
     * @param {number} timeout
     * @param {object} params
     */
    constructor(direction, socketCount, service, module, timeout, params) {
        this.type = STEP_MSCORE_TYPE;
        this.direction = direction;
        this.socketCount = socketCount;
        this.service = service;
        this.module = module;
        this.timeout = timeout;
        this.params = params;
        Object.freeze(this);
    }
}



// WEBPACK FOOTER //
// ./js/public-apis/onclick/EQmScoreStepConfig.js